import React, { Component } from 'react';
import { GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class InputDescripcion extends Component {
    constructor(props) {
        super(props);
        this.changeInput = this.changeInput.bind(this);
        this.changecheckEsConfidencial = this.changecheckEsConfidencial.bind(this);
    }

    changeInput(event) {
        this.props.changeInput("DESCRIPCION", event.target.value)
    }

    changecheckEsConfidencial(event) {
        this.props.changecheckEsConfidencial(event.target.checked)
    }

    render() {
        let me = this;
        let errors;
        const { getFieldProps, getFieldError } = this.props.form;
        let errorContainer;
        let nombreRepetidoEmpresa = this.props.data.ERROR_EMPRESA.nombreRepetido ? null : 'Este nombre ya existe.'

        if (!this.props.data.edicion) {
            errorContainer = <label className="error">
                {(errors = getFieldError('inputDescripcion')) ? errors.join(',') : nombreRepetidoEmpresa }</label>
        } else {
            errorContainer = <label className="error">
                {(errors = getFieldError('inputDescripcion')) ? this.props.form.isFieldTouched("inputDescripcion") ? errors.join(',') : null
                    : nombreRepetidoEmpresa }</label>
        }
        let confidencial = false;
        if (this.props.data.userFunctions != undefined) {
            confidencial = this.props.data.userFunctions.Confidencial;
        }

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-12">
                            <label className="label-primary">Descripción de la empresa (para identificarla en pantalla)</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <GenericInputValidate
                                getFieldProps={getFieldProps('inputDescripcion', {
                                    onChange(e) {
                                        me.changeInput(e);
                                    },
                                    rules: [{
                                        required: true,
                                        message: 'Debe ingresar una descripción.'
                                    }]
                                })}
                                id="inputDescripcion"
                                name="inputDescripcion"
                                value={this.props.data.DescriptionEnterprise}
                                className="form-control default-input"
                                maxLength="100"
                                autoComplete="off"
                            />
                            {errorContainer}
                        </div>
                    </div>
                    {confidencial &&
                        <div className="row">
                            <div className="col-xs-12">
                                <ul className="no-bullets no-padding no-margin">
                                    <li className="inlineListItem2 lg-margin">
                                        <div className="default-checkbox">
                                        <input id="chkEsConfidencial" type="checkbox" onClick={this.changecheckEsConfidencial} checked={this.props.data.checkEsConfidencial} />
                                            <label htmlFor="chkEsConfidencial"></label>
                                        </div>
                                    </li>
                                    <li className="inlineListItem2">
                                        <label className="label-primary" htmlFor="chkEsConfidencial">Es Confidencial</label>
                                    </li>
                                </ul>
                            </div>
                        </div>}
                </div>
            </div>
        );
    }
};

export default InputDescripcion;